import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import TitlePage from 'components/atoms/title-page'
import CardLoader from 'components/organisms/card-loader'
import { ALERT_TYPES } from 'constants/alert-constants'
import PropTypes from 'prop-types'
import CustomerRefundPaymentsApiV2 from 'api/v2/admins/customer-refund-payments-api-v2'
import CustomerRefundsApiV2 from 'api/v2/admins/customer-refunds-api-v2'
import { CustomerRefundPaymentStatusBadge } from 'domains/customer-refund-payment/atoms'
import {
  CustomerRefundPaymentBankDetailCard,
  CustomerRefundPaymentDetailCard,
  CustomerRefundPaymentForm
} from 'domains/customer-refund-payment/organisms'
import { CustomerRefundNoteView } from 'domains/customer-refund/organisms'
import CustomerOrderItemDetailCard from 'domains/customer-order/organisms/item-detail-card'

import withLoader from 'hocs/with-loader'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const CustomerRefundPaymentDetailPage = ({ pageUtils }) => {
  const [ paymentDetail, setPaymentDetail ]       = useState({
    order_number               : '',
    transfer_method            : '',
    customer_bank              : {},
    transaction_no             : '',
    transferred_evidence_image : '',
    status                     : '',
    total_refund               : '',
    refund_requests            : [],
    tl_bank                    : {},
    order_item                 : {},
    transferred_at             : '',
    debit_tl_bank_id           : ''
  })
  const [ image, setImage ]                       = useState(new Blob())
  const { id }                                    = useParams()
  const [ isLoading, setIsLoading ]               = useState(true)
  const [ isPaymentSuccess, setIsPaymentSuccess ] = useState(false)

  useEffect(() => {
    CustomerRefundPaymentsApiV2.show(id)
      .then((response) => {
        const data = response.data.refund_payment
        setPaymentDetail(data)
        setIsLoading(false)
        setIsPaymentSuccess(false)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }, [ id, pageUtils, isPaymentSuccess ])

  const handleCompletePayment = async (values, formikBag) => {
    await CustomerRefundPaymentsApiV2.complete(id, image, values)
      .then(() => {
        pageUtils.setAlertMsg('Transfer is success', ALERT_TYPES.SUCCESS)
        setIsPaymentSuccess(true)
        formikBag.resetForm()
      })
      .catch((error) => {
        formikBag.setErrors(error.response.data.messages)
        pageUtils.setApiErrorMsg(error.response.data)
      })
  }

  // func to update customer refund notes
  const handleUpdateNotes = async (values, formikBag) => {
    await CustomerRefundsApiV2.update(paymentDetail.refund.id, values)
      .then(() => {
        pageUtils.setAlertMsg('successfully updated customer refund', ALERT_TYPES.SUCCESS)
        setIsPaymentSuccess(true)
        formikBag.resetForm()
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }

  const CustomerOrderItemDetailCardWithLoader = withLoader(CustomerOrderItemDetailCard, CardLoader)

  const CustomerRefundPaymentBankDetailCardWithLoader = withLoader(CustomerRefundPaymentBankDetailCard, CardLoader)

  const CustomerRefundPaymentDetailCardWithLoader = withLoader(CustomerRefundPaymentDetailCard, CardLoader)

  const CustomerRefundPaymentFormWithLoader = withLoader(CustomerRefundPaymentForm, CardLoader)

  const CustomerRefundNoteViewWithLoader = withLoader(CustomerRefundNoteView, CardLoader)

  return (
    <>
      <div className='d-flex align-items-center'>
        <TitlePage
          mainTitle='Refund Transfer'
          subTitle={ `#${id}` }
        />
        <div className='ml-2'>
          <CustomerRefundPaymentStatusBadge status={ paymentDetail.status }/>
        </div>
      </div>

      <Row>
        <Col md={ 6 }>
          {
            paymentDetail.status === 'completed' ?
              <CustomerRefundPaymentDetailCardWithLoader
                paymentDetail={ paymentDetail }
                isLoading={ isLoading }
              /> :
              <CustomerRefundPaymentFormWithLoader
                isLoading={ isLoading }
                refundMethod={ paymentDetail.transfer_method }
                paidItemPrice={ paymentDetail.refund?.paid_item_price }
                setImage={ setImage }
                handleCompletePayment={ handleCompletePayment }
              />
          }
        </Col>
        <Col md={ 6 }>
          {
            paymentDetail?.transfer_method === 'cash' && (
              <CustomerRefundPaymentBankDetailCardWithLoader
                customerBank={ paymentDetail.customer_bank }
                isLoading={ isLoading }
              />
            )
          }
          <CustomerOrderItemDetailCardWithLoader
            orderItem={ paymentDetail.order_item }
            isLoading={ isLoading }
          />
        </Col>
      </Row>
      <Row>
        <Col md={ 6 }>
          <Card>
            <CardHeader tag={ 'h3' }>Refund Notes</CardHeader>
            <CardBody>
              <CustomerRefundNoteViewWithLoader
                isLoading={ isLoading }
                refund={ paymentDetail.refund }
                handleSubmitNote={ handleUpdateNotes }
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )

}

CustomerRefundPaymentDetailPage.propTypes    = propTypes
CustomerRefundPaymentDetailPage.defaultProps = defaultProps

export default CustomerRefundPaymentDetailPage
